import { doc, getDoc, DocumentReference } from "firebase/firestore";
import { firestore as db } from "@/utils/firebase";
import { UserFacts } from "./types";

/**
 * Get typed document reference for user facts
 */
const getFactsRef = (userId: string): DocumentReference<UserFacts> =>
  doc(db, "users", userId, "facts", "main") as DocumentReference<UserFacts>;

/**
 * Get user facts document
 * @param userId - The user ID
 * @returns User facts or null if document doesn't exist
 */
export const getUserFacts = async (
  userId: string
): Promise<UserFacts | null> => {
  const docSnap = await getDoc(getFactsRef(userId));
  return docSnap.exists() ? docSnap.data() : null;
};
